import { Component } from '@angular/core';
import { ActivatedRoute, Route, Router, RouterLink, RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { TASKS_DESCRIBE } from '../constants';
import { DynamicRouteService } from 'core';

@Component({
  selector: 'task-tasks',
  imports: [
    TranslocoDirective, 
    MatButtonModule, RouterLink, RouterModule
  ],
  templateUrl: './tasks.html',
  styleUrl: './tasks.scss',
})
export class Tasks {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dynamicRouteService: DynamicRouteService
  ) {
    // console.log("Tasks route", route)
    // console.log("Tasks router config", router.config)

    // Esempio:
    // let pathDetail1 = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'detail');
    // console.log("---> Result detail path:", pathDetail1);
    // let pathDetail2 = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'documents');
    // console.log("---> Result documents path:", pathDetail2);
    // let pathDetail3 = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'list');
    // console.log("---> Result list path:", pathDetail3);
    // let pathDetail4 = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'orders-authorization');
    // console.log("---> Result orders-authorization path:", pathDetail4);
  }

  goToDetail() {
    let qq = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'detail');
    if(qq) {
      qq = this.dynamicRouteService.replacePathSegments(qq, [123]);
      this.router.navigate(qq, {});
    }
  }
  goToList() {
    let qq = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'list');
    if(qq) {
      this.router.navigate(qq, {});
    }
  }

  goToDocuments() {
    let qq = this.dynamicRouteService.getRoutePath(this.router, TASKS_DESCRIBE, 'documents');
    if(qq) {
      qq = this.dynamicRouteService.replacePathSegments(qq, [123]);
      this.router.navigate(qq, {});
    }
  }
}
